// extracted by mini-css-extract-plugin
export default {"panel-parameter--empty":"ReadOnlyParameterPanel_panel-parameter--empty__fmNGA"};